<script lang="ts">
	import ForgotTabs from "../components/ForgotTabs.svelte";
	import Form from "../layouts/Form.svelte";
	import AppLayout from "../layouts/AppLayout.svelte";
	import NewResultLayout from "../layouts/NewResultLayout.svelte";
	//Split
	import { t, api } from "@hitit/hub/src/stores";
	import {
		DefaultButton,
		DefaultTextInput,
		DefaultDone,
		TextButton,
		DefaultLoading,
	} from "@hitit/new_ui/src";
	import { navigate } from "svelte-routing";

	async function submitHandler(e: Event) {
		e.preventDefault();
		if (loading) return;

		try {
			const emailReg =
				/^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*.[a-zA-Z]{2,3}$/i;
			if (!emailReg.test(email)) {
				errorMessage = $t("sso.error.notCorrectEmailForm");
				return;
			}

			loading = true;

			await sendEmail();

			mailSend = true;
		} catch (e) {
			const _e = e as Error;
			if (_e.message == "EmailNotVerified") {
				errorMessage = $t("sso.forgot_password.not_verified_Email");
			} else {
				errorMessage = $t("sso.forgot_password.Email_not_found");
			}
		} finally {
			loading = false;
		}
	}

	async function sendEmail() {
		try {
			await $api.requestPasswordResetEmail(email);
		} catch (e) {
			throw e;
		}
	}

	async function resend() {
		if (loading) return;

		try {
			loading = true;
			await sendEmail();
			sendMessage = $t("sso.forgot_password.resend_success");
		} catch {
			sendMessage = $t("sso.forgot_password.resend_failed");
		} finally {
			loading = false;
		}
	}

	let mailSend = false;
	let loading = false;
	let errorMessage = "";
	let email = "";
	let sendMessage = $t("sso.forgot_password.send_success");

</script>

<AppLayout>
	{#if mailSend}
		<NewResultLayout text={email}>
			<div class="done-box" slot="result-icon">
				<DefaultDone />
			</div>
			<p class="result">{sendMessage}</p>
			<div class="result-buttons">
				{#if loading}
					<DefaultLoading inlineMode />
				{:else}
					<TextButton
						id={'resendButton'}
						text={$t('sso.resend')}
						on:click={resend} />
				{/if}
				<empty />
				<DefaultButton on:click={() => navigate('/')}>
					<span class="white">LOGIN</span>
				</DefaultButton>
			</div>
		</NewResultLayout>
	{:else}
		<Form on:submit={submitHandler}>
			<ForgotTabs active="password" />
			<DefaultTextInput
				clearButtonDisplay={email !== ''}
				clearCallback={() => (email = '')}
				placeholder={$t('sso.username')}
				bind:value={email}
				on:input={() => (errorMessage = '')}
				error={errorMessage !== ''} />
			<p class="error">{errorMessage}</p>
			<DefaultButton disabled={email === '' || loading} isLoading={loading}>
				<span
					class:disabled={email === '' || loading}
					class="white">{$t('sso.forgot_password.send_password_change')}</span>
			</DefaultButton>
		</Form>
	{/if}
</AppLayout>

<style lang="scss">
	p {
		&.result {
			margin-top: 10px;
			margin-bottom: 20px;
			font-size: 1.125rem;
			color: white;
		}

		&.error {
			box-sizing: border-box;
			padding: 10px;
			height: 50px;
			color: var(--error-color-1);
		}
	}
	.done-box {
		width: 121px;
		height: 115.2px;
	}
	.result-buttons {
		display: flex;
		flex-direction: column;
		align-items: center;
		max-width: 400px;
		width: 100%;
		flex-grow: 1;
		max-height: 129px;
	}
	.resend-button {
		width: 5rem;
	}

	span {
		&.white {
			color: white;
			&.disabled {
				color: var(--default-disabled-btn-2);
			}
		}
	}

	empty {
		display: block;
		min-height: 15px;
		flex-grow: 1;
		max-height: 70px;
	}

</style>
